export const DefaultImage = require('../assets/images/default-thumbnail.jpg')
